import isArray from 'lodash/isArray';

import getFilterWithCol from '../../helpers/getFilterWithCol';

import {
  filterSortCreatedUpdatedName,
} from '../../components/common';

const getValueForFieldDefault = value => (
  value && value.length
  ? value
  : undefined
);

export const filterSearch = ['FilterField', {
  id: 'search',
  label: null, // 'ID',
  section: 'top',
  buildQuery: (value, builder) => value && builder.add(
    'where',
    {
      OR: [
        { name: { REGEX: value, OPTIONS: 'i' } },
        { email: { REGEX: value, OPTIONS: 'i' } },
      ],
    }
  ),
  getValueForField: value => value || '',
  getValueForQuery: (value) => {
    value = !value
    ? undefined
    : value.target
    ? value.target.value
    : value;
    return !value || !value.length
    ? undefined
    : value;
  },
  field: ['FieldText', {
    name: 'search',
    placeholder: 'Search name or email',
  }],
}];

export const filterRole = ['FilterField', {
  id: 'role',
  label: null,
  section: 'top',
  VALUES_MAP: {
    any: null,
    admin: { role: { EQ: 'ADMIN' } },
    seller: { role: { EQ: 'SELLER' } },
  },
  buildQuery: (value, builder, filter) => (
    filter.VALUES_MAP[value]
    ? builder.add('where', { ...filter.VALUES_MAP[value] })
    : null
  ),
  getValueForField: value => (
    value && value.length
    ? value
    : undefined
  ),
  field: ['FieldSelect', {
    name: 'role',
    placeholder: 'Role',
    prepareValueForInput: value => (value ? value : 'any'),
    choices: [{
      label: 'Any Role',
      value: 'any',
    }, {
      label: 'Admin',
      value: 'admin',
    }, {
      label: 'Seller',
      value: 'seller',
    }],
  }],
}];

export const filterActive = ['FilterField', {
  id: 'available',
  label: null,
  section: 'top',
  VALUES_MAP: {
    any: null,
    active: { active: { EQ: true } },
    inactive: { active: { EQ: false } },
  },
  buildQuery: (value, builder, filter) => (
    filter.VALUES_MAP[value]
    ? builder.add('where', { ...filter.VALUES_MAP[value] })
    : null
  ),
  getValueForField: value => (
    value && value.length
    ? value
    : 'any'
  ),
  field: ['FieldSelect', {
    name: 'active',
    placeholder: 'Active',
    prepareValueForInput: value => (value ? value : 'any'),
    initialValue: 'any',
    choices: [{
      label: 'Any Status',
      value: 'any',
    }, {
      label: 'Active',
      value: 'active',
    }, {
      label: 'Inactive',
      value: 'inactive',
    }],
  }],
}];

export const filterStore = ['FilterField', {
  id: 'store',
  label: null,
  section: 'top',
  propsFromPage: props => ({ client: props.client }),
  buildQuery: (value, builder) => value && value.length && builder.add(
    'where',
    { store: { IN: isArray(value) ? value : [value] } },
  ),
  getValueForField: getValueForFieldDefault,
  field: ['FieldConnectionSelect', {
    name: 'store',
    url: '/stores/list',
    placeholder: 'Stores',
    mode: 'multiple',
    allowClear: true,
    searchPaths: ['name'],
    // getChoiceLabel: choice => `${(choice.data.name)}`,
  }],
}];

export const filterStoreType = ['FilterField', {
  id: 'type',
  label: null,
  section: 'top',
  VALUES_MAP: {
    any: null,
    merchant: { storeType: { EQ: 'MERCHANT' } },
    referral: { storeType: { EQ: 'REFERRAL' } },
  },
  buildQuery: (value, builder, filter) => (
    filter.VALUES_MAP[value]
    ? builder.add('where', { ...filter.VALUES_MAP[value] })
    : null
  ),
  getValueForField: value => (
    value && value.length
    ? value
    : undefined
  ),
  field: ['FieldSelect', {
    name: 'type',
    placeholder: 'Type',
    prepareValueForInput: value => (value ? value : 'any'),
    choices: [{
      label: 'Any Store Type',
      value: 'any',
    }, {
      label: 'Merchant',
      value: 'merchant',
    }, {
      label: 'Referral',
      value: 'referral',
    }],
  }],
}];

export const filterPagination = ['FilterPagination', {
  id: 'pagination',
  section: 'bottom',
}];

export const filterNotSignups = ['FilterHidden', {
  id: 'nonSignupUsers',
  section: 'bottom',
  build: builder => builder.add('where', { signup: { NE: true } }),
}];

export const filterAdmins = ['FilterHidden', {
  id: 'admins',
  section: 'bottom',
  build: builder => builder.add('where', { role: { EQ: 'ADMIN' } }),
}];

export const filterSellers = ['FilterHidden', {
  id: 'sellers',
  section: 'bottom',
  build: builder => builder.add('where', { role: { EQ: 'SELLER' } }),
}];

export const filterPopulateStore = ['FilterHidden', {
  id: 'populateStore',
  section: 'bottom',
  build: builder => builder.add('populate', { store: { name: true } }),
}];

export const ADMIN_ALL = [
  ...[
    [filterSearch, 8],
    [filterActive, 8],
    [filterSortCreatedUpdatedName, 8],
  ].map(args => getFilterWithCol(...args)),

  filterPagination,
  filterNotSignups,
  filterAdmins,
];

export const ADMIN_SELLERS = [
  ...[
    [filterSearch, 8],
    [filterActive, 8],
    [filterSortCreatedUpdatedName, 8],
    [filterStore, 12],
    [filterStoreType, 12],
  ].map(args => getFilterWithCol(...args)),

  filterPagination,
  filterNotSignups,
  filterPopulateStore,
  filterSellers,
];
